<rn-background-accent setHeightFromSelector=".circulation"/>

@if (data$ | async; as data) {
  <ng-container *ngTemplateOutlet="mainContent; context: { data: data }"/>
}

<ng-template #mainContent let-data="data">
  <div class="main-content flex-row-wrap flex-center-space-around">
    <div class="left-column">
      <rn-image-container [catalogRecord]="data.item" alt="Book Cover"/>
      @if (!mobile) {
        <ng-container *ngTemplateOutlet="belowCover"/>
      }
    </div>
    <div class="right-column flex-col">
      <div class="title-row flex-row flex-center-space-between">
        <h2 class="title">{{ data.item.title }}</h2>
        @if (!mobile) {
          <div class="item-status">
            <ng-container *ngTemplateOutlet="itemStatus"/>
          </div>
        }
      </div>
      <span class="author">Author: {{ data.item.author ? data.item.author : 'Not Available' }}</span>
      <span class="pickup-location">Pickup Location: {{ data.item.pickupBranchName ? data.item.pickupBranchName : 'Not available' }}</span>
      <span class="isbn">ISBN: {{ data.item.isbn ? data.item.isbn : 'Not Available' }}</span>
      @if (mobile) {
        <ng-container *ngTemplateOutlet="itemStatus"/>
      }
      <div class="circulation">
        <ng-content select="[project=circulationInfo]"/>
      </div>
      <div class="actions">
        <ng-content select="[project=actions]"/>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #belowCover>
  <ng-content select="[project=belowCover]"/>
</ng-template>

<ng-template #itemStatus>
  <ng-content select="[project=statusPill]"/>
</ng-template>
